export const tableStyles = {
    '& .MuiTableHead-root .MuiTableCell-head': {
        borderBottom: 'none',
        color: '#000',
        fontSize: '12px',
        fontWeight: '600',
        lineHeight: '16px',
        '&.table-suppliers': {
            fontSize: '15px',
        },
    },
    '& .out-of-stock': {
        backgroundColor: '#F8F8F8',
    },
    '& .MuiTableBody-root .MuiTableCell-root': {
        '&:first-of-type': {
            borderTop: '1px solid',
            borderBottom: '1px solid',
            borderLeft: '1px solid',
            borderColor: 'grey.500',
            borderRadius: '4px 0px 0px 4px',
        },
        '&:last-of-type': {
            borderTop: '1px solid',
            borderBottom: '1px solid',
            borderRight: '1px solid',
            borderRadius: '0px 4px 4px 0px',
            borderColor: 'grey.500',
        },
        '&': {
            borderTop: '1px solid',
            borderColor: 'grey.500',
            paddingTop: '17px',
            paddingBottom: '17px',
        },
    },
    borderCollapse: 'collapse',
    borderSpacing: '0',
};

export const columnStyles = {
    suppliers: {
        textAlign: 'left',
        paddingLeft: '20px',
        paddingRight: '15px',
    },
    unitCost: {
        textAlign: 'right',
        paddingLeft: '0px',
        paddingRight: '20px',
        width: '80px',
    },
    stock: {
        textAlign: 'right',
        paddingLeft: '0px',
        paddingRight: '50px',
        width: '40px',
    },
    qty: {
        position: 'relative',
        textAlign: 'center',
        paddingLeft: '0px',
        paddingRight: '15px',
        width: '102px',
    },
    total: {
        textAlign: 'right',
        paddingLeft: '0px',
        paddingRight: '20px',
        width: '100px',
    },
};
